// Copyright (c) Bentley Systems, Incorporated. All rights reserved.
export default [
  "__gCrWeb",
]
